/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum ControlPanelLocation {
    Recorder = 1,
    Tablet = 2,
    ArchiveControls = 4,
    EventSelection = 5,
    PresentationCommander = 6,
    ParticipationView = 7,
    LiveViewController = 8,
    MultiRoomRecording = 9,
}
